module.exports = __webpack_public_path__ + "img/save.00978440.svg";